// Copyright 2024, Imprivata, Inc.  All rights reserved.

export const Endpoints = {
  AAD_CONSENT_URL: '/am-portal-setup-svc/tenant-setup/v1/aad-consent-url/get',
  COMPLETE_SETUP: '/am-portal-setup-svc/tenant-setup/v1/complete',
  CONSENT_CHECK: '/am-portal-svc/user-consent/v1/consent/check',
  CONSENT_SUBMIT: '/am-portal-svc/user-consent/v1/consent/submit',
  CONSENT_REVOKE: '/am-portal-svc/user-consent/v1/consent/revoke',
  DIR_FAILED_SYNC_FIND: '/am-portal-svc/directory/v1/directories/failed-sync/find',
  DIR_FIND: '/am-portal-svc/directory/v1/directories/find',
  DIR_SYNC_PROGRESS: '/am-portal-svc/directory/v1/directories/sync-progress/get',
  DOMAINS_VALIDATE: '/am-portal-setup-svc/tenant-service/v1/domains/validate',
  DPA_CHECK: '/am-portal-setup-svc/user-consent/v2/consent/dpa-check',
  ENTRA_ID_AUTHN_TEST: '/am-portal-svc/entra-id/v1/entra-id/authentication/test',
  ENTRA_ID_CONSENT: '/am-portal-svc/entra-id/v1/entra-id-consent-url/get',
  ENTRA_ID_SETUP_COMPLETE: '/am-portal-svc/entra-id/v1/entra-id/setup',
  FIND_AUTHENTICATORS: '/am-portal-svc/authenticators/v1/find/by-user-ids',
  GET_CLIENT_USER_SESSION: '/am-portal-svc/session/v1/client-user-session/get',
  GET_GROUPS: '/am-portal-svc/identity-group/v1/groups/find',
  GET_LANDING_PAGE: '/am-portal-svc/v2/landing-page/get',
  GET_IDP_CONFIG_SAML: '/am-portal-svc/icp-config-admin/v1/idp-config-saml/get',
  IDP_CONFIG_SAML_FIND: '/am-portal-setup-svc/icp-config-admin/v1/idp-config-saml/find',
  IP_RANGES: '/am-portal-svc/entra-id/v1/entra-id-config/get',
  GROUPS_FIND: '/am-portal-svc/identity-group/v1/groups/find',
  LOGOUT: '/idp-web/idp/logout',
  ORG_INFO_GET: '/am-portal-setup-svc/organization-info/v1/get',
  ORG_INFO_SAVE: '/am-portal-setup-svc/organization-info/v1/save',
  PORTAL_CONFIG_SETTINGS_GET: '/am-portal-svc/config/v1/settings/get',
  PORTAL_CONFIG_SETTINGS_UPDATE: '/am-portal-svc/config/v1/settings/update',
  PORTAL_TEMP_CODE_ASSIGN: '/am-portal-svc/temp-code/v1/temp-code/assign',
  PORTAL_TEMP_CODE_METADATA_GET: '/am-portal-svc/temp-code/v1/temp-code-metadata/get',
  PORTAL_CREATE_CLIENT_CREDENTIAL:
    '/am-portal-svc/connect-administration/v1/client-credential/create',
  PORTAL_CREDENTIALS_FIND: '/am-portal-svc/credentials/v1/credentials/find',
  PORTAL_CREDENTIALS_DELETE: '/am-portal-svc/credentials/v1/credential/delete',
  PORTAL_IMPR_IDP_DIR_SAVE: '/am-portal-svc/impr-idp-directories/v1/save',
  PORTAL_IMPR_IDP_USER_DETAILS_GET: '/am-portal-svc/impr-idp-users/v1/user/get',
  PORTAL_IMPR_IDP_USERS_FIND: '/am-portal-svc/impr-idp-users/v1/find',
  PORTAL_IMPR_IDP_USERS_SAVE: '/am-portal-svc/impr-idp-users/v1/save',
  PORTAL_IMPR_IDP_USERS_DELETE: '/am-portal-svc/impr-idp-users/v1/delete',
  PORTAL_ORG_PREFERENCES_GET: '/am-portal-svc/preferences/v1/org-preferences/get',
  PORTAL_ORG_PREFERENCES_UPDATE: '/am-portal-svc/preferences/v1/org-preferences/update',
  PORTAL_IMPR_IDP_USERS_INVITE: '/am-portal-svc/impr-idp-users/v1/users/invite',
  PORTAL_IMPR_IDP_USERS_UNLOCK: '/am-portal-svc/impr-idp-users/v1/user/unlock',
  PORTAL_IMPR_IDP_USERS_FACTOR_LOCKOUT_CLEAR:
    '/am-portal-svc/impr-idp-users/v1/user/factor-lockout/clear',
  PORTAL_USERS_FACTOR_LOCKOUT_CLEAR: '/am-portal-svc/user/v1/user/factor-lockout/clear',
  PORTAL_PASSWORD_EXPIRATION: '/am-portal-svc/password-info/v1/get',
  PORTAL_USERS_UPLOAD_SUBMIT: '/am-portal-svc/users/upload/v1/import-file/submit',
  PORTAL_USERS_UPLOAD_TEMPLATE_GET: '/am-portal-svc/users/upload/v1/import-file-template/get',
  PORTAL_REPORTS_EPCS_AUDIT_GET: '/am-portal-svc/reports/v1/epcs-audit/get',
  PORTAL_REPORTS_LOGIN_ACTIVITY_GET: '/am-portal-svc/reports/v1/login-activity/get',
  PORTAL_REPORTS_AGENT_VERSION_GET: '/am-portal-svc/reports/v1/agent-version/get',
  PORTAL_REPORTS_USER_ENROLLMENT_GET: '/am-portal-svc/reports/v1/user-enrollment/get',
  SETUP_IMPR_IDP_DIR_ADD: '/am-portal-setup-svc/impr-idp-directories/v1/save',
  SETUP_CREATE_CLIENT_CREDENTIAL:
    '/am-portal-setup-svc/connect-administration/v1/client-credential/create',
  SETUP_LINK_REGENERATE: '/am-portal-setup-svc/tenant-setup/v1/setup-link/regenerate',
  START_TENANT_SETUP: '/am-portal-setup-svc/tenant-setup/v1/start',
  TENANT_LOOKUP_BY_DOMAIN: '/am-portal-svc/tenant-lookup/v1/tenants-by-domain/get',
  TENANT_INFO: '/am-portal-svc/tenant-service/v2/tenant-info/get',
  UNENROLL_AUTHENTICATORS: '/am-portal-svc/authenticators/v1/unenroll',
  USERS_FIND: '/am-portal-svc/user/v1/users/find',
  // typescript:S2068 hard-coded passwords
  SELF_SERVICE_CHANGE_PASSWORD: '/am-portal-svc/impr-idp-users/v1/password/change', // NOSONAR
  SELF_SERVICE_V1_ENROLL: '/am-portal-svc/user-self-service/v1/authenticator/enroll',
  SELF_SERVICE_V2_LANDING_PAGE_GET: '/am-portal-svc/user-self-service/v2/landing-page/get',
  SELF_SERVICE_OTP_CONFIRM: '/am-portal-svc/user-self-service/v2/email-verification/confirm',
  SELF_SERVICE_OTP_REQUEST: '/am-portal-svc/user-self-service/v2/email-verification/request',

  USER_WEB_SUPERVISED_ASSURANCE_CANCEL: '/user-web/supervised-assurance/v1/assurance/cancel',
  USER_WEB_SUPERVISED_ASSURANCE_START: '/user-web/supervised-assurance/v1/assurance/start',
  USER_WEB_SUPERVISED_ASSURANCE_IDENTITY_VERIFICATION_RECORD:
    '/user-web/supervised-assurance/v1/identity-verification/record',
  USER_WEB_SUPERVISED_ASSURANCE_AUTHENTICATOR_VERIFY:
    '/user-web/supervised-assurance/v1/authenticator/verify',
  USER_WEB_SUPERVISED_ASSURANCE_COMPLETE: '/user-web/supervised-assurance/v1/assurance/complete',

  LEGAL_AGREEMENTS_PREPARE: '/am-portal-svc/legal-agreements/v1/file-upload/prepare',
  LEGAL_AGREEMENTS_COMPLETE: '/am-portal-svc/legal-agreements/v1/file-upload/html-to-json/complete',
  LEGAL_AGREEMENTS_INFO_GET: '/am-portal-svc/legal-agreements/v1/customer-agreement-info/get',
  // Setup and Portal
  PREPARE_FILE_UPLOAD: '/am-portal-svc/file-access/v1/prepare-file-upload',
  SAVE_AND_UPDATE_IDP_CONFIG_SAML: '/am-portal-svc/icp-config-admin/v1/idp-config-saml/save',
  IMPR_IDP_DIR_FIND: '/am-portal-svc/impr-idp-directories/v1/find',
  CONNECT_CLIENT_CREATE: '/am-portal-svc/connect-eamc/v1/client/create',
  IDP_GET: '/am-portal-svc/icp-metadata-admin/v1/idp/get',
  IDP_SAVE: '/am-portal-svc/icp-metadata-admin/v1/idp/save',
  IDP_GET_DATA: '/am-portal-svc/impr-idp-directories/v1/impr-idp-data/get',
  PASSWORD_POLICY_GET: '/am-portal-svc/config/v1/password-policy/get',
  PASSWORD_POLICY_UPDATE: '/am-portal-svc/config/v1/password-policy/update',
  AUTHENTICATION_STRENGTH_GET: '/am-portal-svc/config/v1/authentication-strength/get',
  APP_INTEGRATION_FIND_BY_NAME: '/admin-web/applications/v2/app-integration/find/by-name',
  APP_CONFIG_FIND: '/admin-web/application-config/v1/app-config/find',
  APP_CONFIG_UPDATE: '/admin-web/application-config/v1/app-config/update',
  PROX_CARD_MAX_NUMBER_GET: '/am-portal-svc/config/v1/prox-card-max-number/get',
  PROX_CARD_MAX_NUMBER_UPDATE: '/am-portal-svc/config/v1/prox-card-max-number/update',
} as const;

export enum ClientHeader {
  SETUP = 'am-portal-tenant-setup-web',
  IDP_WEB = 'idp-web',
}

export enum AMPortalService {
  AM_PORTAL_SETUP = '/am-portal-setup-svc',
  AM_PORTAL = '/am-portal-svc',
}

export enum SystemType {
  SETUP = 'SETUP',
  PORTAL = 'PORTAL',
}

export const CommonHeadersJson = { Accept: 'application/json', 'Content-Type': 'application/json' };

export const IdpChoices = {
  ENTRA_ID_VALUE: 'entraId',
  EXTERNAL_VALUE: 'external',
  NONE_VALUE: 'none',
} as const;

export const StorageKeys = {
  WORKFLOW_ID: 'ImprWorkflowId',
  TENANT_SETUP_STATE: 'tenantSetupState', // type SetupState
  DPA_STATUS: 'DPA_STATUS', // type DpaStatus
  DPA_DOCUMENT_NAME: 'DPA_DOCUMENT_NAME',
  DPA_DOCUMENT_URL: 'DPA_DOCUMENT_URL',
  ORG_EMAIL: 'orgEmail',
  IMPR_IDP_USED: 'IMPR_IDP_USED', // type boolean
};

export const RegexPatterns = {
  STRING_START: '^',
  REQUIRE_ALPHABETIC: '(?=.*[A-Za-z])',
  REQUIRE_NUMERIC: '(?=.*\\d)',
  REQUIRE_SPECIAL: '(?=.*[^A-Za-z\\d])',
  REQUIRE_LOWERCASE: '(?=.*[a-z])',
  REQUIRE_UPPERCASE: '(?=.*[A-Z])',
  STRING_END: '$',
};

export enum SetupState {
  STARTED = 'started',
  COMPLETED = 'completed',
}

export enum DpaStatus {
  GRANTED = 'GRANTED',
}

export enum ConsentGrantType {
  GRANTED = 'granted',
  NOT_GRANTED = 'not-granted',
  EMPTY = '',
}

export enum ConsentType {
  BIOMETRICS = 'impr.biometrics',
}

export enum SearchParams {
  BEARER_TOKEN = 'bt',
  TENANT_ID = 'tenantId',
  STATE = 'state',
  WINDOW_CLOSE_SEC = 'windowCloseSec',
}

export const defaultSystemData = { version: '1.0', osName: '', osVersion: '', computerName: '' };

// please add values as you need them
export enum Entitlement {
  EPCS = 'epcs',
  FACE_RECOGNITION = 'face-recognition',
  SSO = 'sso',
}
